export const styles = {
  container: "min-h-screen flex flex-col items-center justify-center",
  iconWrapper: "flex flex-col",
  title: "text-[30px] font-bold mt-10",
  paragraph: "mt-5 text-[18px] font-semibold",
  paragraphTight: "mt-2 text-[18px] font-semibold",
  boldText: "font-bold",
  linkText: "font-bold cursor-pointer text-primary-100",
  supportText: "mt-2 text-[18px] font-semibold",
  button: "py-[15px] mt-10 px-[60px] confirmation-go-home",
};
